import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import FieldDisplay from '../../../../../../molecules/FieldDisplay'

function PaginationDisplay ({ pagination }) {
  const fields = useMemo(() => [
    { label: 'Default Page Size', value: pagination.defaultPageSize },
    { label: 'Max Page Size', value: pagination.maxPageSize }
  ], [pagination])

  return (
    <div style={{ marginBottom: '16px' }}>
      <h4>Pagination</h4>
      <FieldDisplay fields={fields} />
    </div>
  )
}

PaginationDisplay.propTypes = {
  pagination: PropTypes.object.isRequired
}

export default PaginationDisplay
